export default {
  data() {
    return {
      planning: { num_package_groups: 22, package_detail_id: 0 },
      package_group_plannings: [],
      package_plannings: [],
      sizes: [],
      brands: [],
      container: {},
    }
  },
  computed: {
    default_agro_exporter_brand_id: function () {
      const by_container = this.container?.agro_exporter_brand_id;
      const by_sizes = this.sizes.length > 0 ? this.sizes[0].id : null;
      return by_container || by_sizes;
    },
    filtered_package_plannings: function () {
      return this.package_plannings.filter(package_planning => Number(package_planning.num_packages) > 0);
    },
    filtered_package_group_plannings: function () {
      return this.package_group_plannings.filter(package_group_planning => Number(package_group_planning.num_package_groups) > 0);
    },
    is_detailed_per_pg: function () {
      return this.planning.package_detail_id == 1;
    },
    is_detailed_per_package: function () {
      return this.planning.package_detail_id == 2;
    },
    num_total_packages: function () {
      const total =
        Number(this.planning.num_package_groups) * Number(this.planning.packages_per_pg);

      return total || 0;
    },
    params: function () {
      const container_planning = this.planning;
      container_planning.num_total_packages = this.num_total_packages;
      return container_planning;
    },
  },
}